import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export class Utils {
  public static validateAllFormFields(formGroup: UntypedFormGroup) {
    //{1}
    Object.keys(formGroup.controls).forEach((field) => {
      //{2}
      const control = formGroup.get(field); //{3}
      if (control instanceof UntypedFormControl) {
        //{4}
        control.updateValueAndValidity({ onlySelf: true }); // Fix for not required Fields but has other validators
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        //{5}
        this.validateAllFormFields(control); //{6}
      }
    });
  }

  public static patchFormValue(formGroup: UntypedFormGroup, values) {
    Object.keys(values).forEach((key) => {
      formGroup.controls[key].patchValue(values[key], { onlySelf: true, emitEvent: false });
    });
  }
  public static inputMatch(controlName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let error = true;
      const formGroup = control.parent as UntypedFormGroup;
      if (formGroup) {
        const firstValue = formGroup.value[controlName];
        const secondValue = control.value;
        error = firstValue !== secondValue;
      }
      return error ? { inputMatch: { value: control.value } } : null;
    };
  }
  public static checkRequired(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => (!control.value ? { checkRequired: { value: control.value } } : null);
  }
}
